import * as React from 'react'

import { Button } from '../../../../main/components/button'
import { SpecificChartFunctionality, TIMEFRAME } from '../../../../main/constants'
import { Instrument } from '../../../../main/types'
import { FuturesForexCryptoTimeframeBar } from '../../../shared/components/FuturesForexCryptoTimeframeBar'
import { PageType } from '../../types'

interface MenuProps {
  isDetailOpen?: boolean
  activePage: PageType
  timeframes: {
    active: string
    link?: (timeframe: string) => string
    onClick: (timeframe: string, e: React.MouseEvent<HTMLElement>) => void
    timeframes: Array<{ key: string; title?: string; value: React.ReactNode }>
  }
  company?: string
  onTimeframeChange?: (timeframe: TIMEFRAME) => void
  onDateRangeChange?: (dateRange: string | undefined) => void
}

export default function Menu({
  isDetailOpen,
  activePage,
  timeframes,
  company,
  onTimeframeChange,
  onDateRangeChange,
}: MenuProps) {
  return (
    <div className="flex h-12 items-center justify-between py-2.5">
      <div className="flex space-x-px font-sans">
        <Button as="a" href="/forex.ashx" active={activePage === PageType.Quotes} theme="chipTransparent">
          Quotes
        </Button>
        <Button
          as="a"
          href="/forex_performance.ashx"
          theme="chipTransparent"
          active={activePage === PageType.Performance}
        >
          Performance
        </Button>
        <Button as="a" href="/forex_charts.ashx" theme="chipTransparent" active={activePage === PageType.Charts}>
          Charts
        </Button>
      </div>
      <div className="flex w-64 justify-end space-x-px font-sans xl:w-96">
        {activePage === PageType.Charts ? (
          <FuturesForexCryptoTimeframeBar
            isDetail={isDetailOpen}
            title="Forex"
            group={company}
            onTimeframeChange={onTimeframeChange}
            onDateRangeChange={onDateRangeChange}
            specificChartFunctionality={SpecificChartFunctionality.forexPage}
            instrument={Instrument.Forex}
          />
        ) : (
          timeframes.timeframes.map((timeframe) => (
            <Button
              key={timeframe.key}
              as={timeframes.link ? 'a' : 'button'}
              {...{ href: timeframes.link?.(timeframe.key) }}
              theme="chipTransparent"
              padding="small"
              active={timeframes.active === timeframe.key}
              onClick={(ev: React.MouseEvent<HTMLButtonElement>) => timeframes.onClick?.(timeframe.key, ev)}
              title={timeframe.title}
            >
              {timeframe.value}
            </Button>
          ))
        )}
      </div>
    </div>
  )
}
